export default __webpack_public_path__ + "static/media/facebook_user.f9b687b1.jpg";